var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconFailedMedium(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_failed_medium") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_failed_medium",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.89441518,1.78883037 C8.40044332,0.800886637 7.60327876,0.793442488 7.10558482,1.78883037 L0.894415185,14.2111696 C0.400443318,15.1991134 0.894513756,16 1.99406028,16 L14.0059397,16 C15.1072288,16 15.6032788,15.2065575 15.1055848,14.2111696 L8.89441518,1.78883037 Z",
    id: "Page-1",
    fill: "#C60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,11.1095529 L8,11.1095529 C7.50933333,11.1095529 7.11111111,10.6879059 7.11111111,10.1683765 L7.11111111,5.46249412 C7.11111111,4.94296471 7.50933333,4.52131765 8,4.52131765 L8,4.52131765 C8.49066667,4.52131765 8.88888889,4.94296471 8.88888889,5.46249412 L8.88888889,10.1683765 C8.88888889,10.6879059 8.49066667,11.1095529 8,11.1095529",
    id: "Fill-1",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,13.9330824 L8,13.9330824 C7.50933333,13.9330824 7.11111111,13.5114353 7.11111111,12.9919059 L7.11111111,12.9919059 C7.11111111,12.4723765 7.50933333,12.0507294 8,12.0507294 L8,12.0507294 C8.49066667,12.0507294 8.88888889,12.4723765 8.88888889,12.9919059 L8.88888889,12.9919059 C8.88888889,13.5114353 8.49066667,13.9330824 8,13.9330824",
    id: "Fill-3",
    fill: "#FFFFFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFailedMedium);
export default __webpack_public_path__ + "static/media/icon_failed_medium.7096cbd19d526cf3e3120c2d9fa75ec6.svg";
export { ForwardRef as ReactComponent };